module.exports = __webpack_public_path__ + "img/DE03619.5d7066b7.png";